module.exports = __webpack_public_path__ + "static/media/Embassy Referral.1575c248.png";